'use strict';

import angular from 'angular';

export default class FinTxnSelectCtrl {
  constructor($state, $stateParams, $location, $filter, LoaderSvc, moment,
    DatetimeSvc, GroupSvc, GroupAuthSvc, GrpTxnSvc, PaymentModalSvc) {
    LoaderSvc.start('Loading...');
    var that = this;
    var ctxId = $stateParams.ctxId;
    this.ctxId = ctxId; // set for group urls
    var groupId = $stateParams.groupId;
    this.groupId = groupId; // set for group urls

    that.dataModel = 'gtvm'; // NOTE: AS of 1/19/19, not sure what this does...

    that.groupTransactions = [];
    var allMemberTransactions = []; // all transactions for time period & group
    that.memberTransactions = []; // filtered transactions for split dues

    ////////////////////////////////////////////////////////////////////////////
    /// Select price date (super admin only)
    ////////////////////////////////////////////////////////////////////////////
    // datepicker
    that.today = new Date();
    that.formvm = {formPriceDate: new Date()};
    that.dateFormat = 'M/d/yy';
    that.openActive = function($event, dateType) {
      $event.preventDefault();
      $event.stopPropagation();
      that.formvm[dateType + 'Open'] = true;
    };

    that.enablePriceDate = function() {
      that.editPriceDate = true;
    };

    that.updatePriceDate = function() {
      that.editPriceDate = false;
      that.getTransactions();
      that.getMemberDues();
    };

    ////////////////////////////////////////////////////////////////////////////
    /// Get items for group
    ////////////////////////////////////////////////////////////////////////////
    var timePeriodHash = {};
    var toGroupsHash = {};

    // 1. get time periods
    GroupSvc.getTimePeriods({groupId: ctxId}).$promise
      .then(function(tp) {
      /**
       * TODO: Remove redundant filters used by financial, group and member txn
       * TODO: Update time periods to have effective end dates
       */
        // ignore values without effective start
        var today = moment();
        tp = tp.filter(function(per) {
          var tpEnd = per.effectiveEnd || per.end;
          var isActive = per.effectiveStart
          && today.isSameOrAfter(DatetimeSvc.parseUTCDate(per.effectiveStart))
          && today.isSameOrBefore(DatetimeSvc.parseUTCDate(tpEnd, true));
          if(isActive) { timePeriodHash[per.id] = per; }
          return isActive;
        });
        tp = $filter('orderBy')(tp, 'start', true);
        // initialize time periods with current time period
        for(var i = 0; i < tp.length; i++) {
          var per = tp[i];
          var effectiveStart = per.effectiveStart || per.start;
          if(today.isSameOrAfter(DatetimeSvc.parseUTCDate(effectiveStart))
        && today.isSameOrBefore(DatetimeSvc.parseUTCDate(per.end, true))) {
            that.tpFilter = per.id;
            break;
          }
        }
        that.timePeriods = tp;
        LoaderSvc.stop();
        that.getTransactions();
      });

    that.getTransactions = function() {
      LoaderSvc.start('Loading Transactions...');

      var asOfDate = DatetimeSvc.getDatePropString(that.formvm.formPriceDate);
      // 2. get transactions
      GrpTxnSvc.query({groupId, tpId: that.tpFilter, date: asOfDate}).$promise
        .then(function(gt) {
          that.groupUnpaidCount = 0;
          // map time periods for filtering
          gt = gt.map(function(d) {
          // get all unique paid to groups
            if(d.toGroup && !toGroupsHash[d.toGroup.id]) {
              toGroupsHash[d.toGroup.id] = d.toGroup;
            }
            // set status - note desc sort results in Unpaid > Submitted > Paid
            if(!d.financialTransaction) {
              d.status = 'Unpaid';
              that.groupUnpaidCount++;
            } else if(d.financialTransaction.acceptedAt) {
              d.status = 'Paid';
            } else if(d.financialTransaction.submittedAt) {
              d.status = 'Submitted';
            }

            return d;
          });
          // filter out payments previously made (net transactions)
          gt = gt.filter(function(txn) {
            return !txn.financialTransaction || txn.invoiceType !== 'net';
          });
          that.groupTransactions = gt;
          that.order = 'date';
          that.searchField = 'name';
        })
        .catch(function() {
          LoaderSvc.stopError('Error loading Group Transactions');
        })
        .then(function() {
          that.memberUnpaidCount = 0;
          // 3. get member transactions
          GrpTxnSvc.queryMembers({groupId, tpId: that.tpFilter, date: asOfDate})
            .$promise
            .then(function(mt) {
              var memberHash = {};
              var memberDuesTypesHash = {};

              // filter out null/zero value items
              mt = mt.filter(function(d) {
                return d.amount && d.amount !== 0;
              });


              // map time periods for filtering
              mt.forEach(function(d) {
                // get all unique paid to groups
                if(d.toGroup && !toGroupsHash[d.toGroup.id]) {
                  toGroupsHash[d.toGroup.id] = d.toGroup;
                }

                var personId = d.person.id;
                // set status
                // NOTE: desc sort results in Unpaid > Submitted > Paid
                if(!d.financialTransaction) {
                  d.status = 'Unpaid';

                  // get unique member dues for payment
                  if(d.memberFee && d.memberFee.type == 'dues'
              && d.timePeriodId == that.tpFilter
              && !memberDuesTypesHash[d.memberFee.id]) {
                    memberDuesTypesHash[d.memberFee.id] = d.memberFee;
                    memberDuesTypesHash[d.memberFee.id].toGroupId = d.toGroupId;
                  }
                } else if(d.invoiceType === 'net') {
                  // filter out payments previously made (net transactions)
                  // no action required
                } else if(d.financialTransaction.acceptedAt) {
                  d.status = 'Paid';
                } else if(d.financialTransaction.submittedAt) {
                  d.status = 'Submitted';
                }

                // use status to organize
                if(d.status) {
                  // init person in hash
                  if(!memberHash[personId]) {
                    memberHash[personId] = {};
                  }

                  // init person and toGroup in hash
                  if(!memberHash[personId][d.toGroup.id]) {
                    memberHash[personId][d.toGroup.id] = {
                      itemsUnpaid: [],
                      itemsSubmitted: [], // unpaid
                      itemsPaid: [],
                      person: d.person,
                      toGroup: d.toGroup,
                      toGroupId: d.toGroup.id
                    };
                  }
                  memberHash[personId][d.toGroup.id]['items' + d.status]
                    .push(d);
                }
              });

              // convert member transations from hash to array
              var mtArray = [];
              for(var personId in memberHash) {
                for(var toGrpId in memberHash[personId]) {
                  if(memberHash[personId][toGrpId].amount !== 0) {
                    that.memberUnpaidCount++;
                  }
                  mtArray.push(memberHash[personId][toGrpId]);
                }
              }
              allMemberTransactions = mtArray;
              that.filterMemberDues();

              // convert toGroupsHash to array
              that.toGroups = [];
              that.toGroupsAdmin = [];
              for(var g in toGroupsHash) {
                var toGroupId = toGroupsHash[g].id;
                toGroupsHash[g].userHasToGroupUpdate
                  = GroupAuthSvc.hasPermission(
                    toGroupId, 'financialTransaction', 'U');
                that.toGroups.push(toGroupsHash[g]);

                // expose the toGroups that
                // this user can administer/change dates
                // note this does NOT inherit permissions,
                // so staff cannot edit dates for districts
                if(GroupAuthSvc.hasPermission(toGroupId,
                  'financialTransaction', 'U')) {
                  that.toGroupsAdmin.push(toGroupId);
                }
              }
              if(that.toGroups && that.toGroups[0]) {
                that.toGroupFilter = that.toGroups[0].id;
              }

              // dues filter: convert memberDuesTypesHash to selection array
              that.memberDuesTypes = [];
              for(var md in memberDuesTypesHash) {
                // ensure sorts after 'All'
                memberDuesTypesHash[md].sortOrder = 2;
                that.memberDuesTypes.push(memberDuesTypesHash[md]);
              }

              for(var h in toGroupsHash) {
                that.memberDuesTypes.push({
                  id: '', name: 'All',
                  toGroupId: toGroupsHash[h].id,
                  sortOrder: 1
                });
              }
              // default to All
              that.memberDuesTypesFilter = '';

              that.order = 'date';
              that.searchField = 'name';
              LoaderSvc.stop();
            })
            .catch(function() {
              LoaderSvc.stopError('Error loading Member Transactions');
            });
        });
    };


    // for dues only, allow selection/filtering
    function filterMemberDuesBySelection(item) {
      return !that.memberDuesTypesFilter
        || !item.memberFee
        || item.memberFee.type != 'dues'
        || item.memberFee.id == that.memberDuesTypesFilter;
    }

    // filter based on dues selection
    // (e.g. split dues for the year into part 1 & 2)
    that.filterMemberDues = function() {
      var memberTransactions = [];
      for(var member in allMemberTransactions) {
        var memberCopy = angular.copy(allMemberTransactions[member]);
        memberCopy.itemsUnpaid = memberCopy
          .itemsUnpaid.filter(filterMemberDuesBySelection);
        memberCopy.amount = 0;
        // eslint-disable-next-line no-loop-func
        memberCopy.itemsUnpaid.forEach(function(unpaidItem) {
          memberCopy.amount += unpaidItem.amount || 0;
        });
        memberTransactions.push(memberCopy);
      }
      that.memberTransactions = memberTransactions;
    };

    ////////////////////////////////////////////////////////////////////////////
    /// Toggle Selected Items
    ////////////////////////////////////////////////////////////////////////////
    that.toggleAll = toggleAll;
    function toggleAll(items, type) {
      if(['Group', 'Member'].indexOf(type) < 0) { return; }
      var selectProperty = 'selectAll' + type + 'Items';
      var toggleToGroupId = that.toGroupFilter;

      // toggle to new selectProperty
      var newValue = that[selectProperty] ? false : true; // eslint-disable-line
      that[selectProperty] = newValue;
      items.map(function(item) {
        switch (type) {
        case 'Group':
          if(!newValue) { // deselecting everything, all become false
            item.selected = false;
          } else if(item.amount !== 0
          && item.toGroup.id === toggleToGroupId // validate selected group
          && item.status !== 'Submitted' && item.status !== 'Paid') {
            item.selected = true;
          }
          break;
        case 'Member':
          if(!newValue) { // deselecting everything, all become false
            item.selected = false;
          } else if(item.amount !== 0
            && item.toGroup.id === toggleToGroupId // validate selected group
            && item.itemsUnpaid.length > 0) {
            item.selected = true;
          }
          break;
        }

        return item;
      });
    }

    ////////////////////////////////////////////////////////////////////////////
    /// Open Payment Method Modal
    ////////////////////////////////////////////////////////////////////////////
    var selectedFilter = function(item) { return item.selected; };

    that.openPayment = function() {
      var paymentObj = {
        fromGroupId: that.groupId,
        timePeriod: timePeriodHash[that.tpFilter],
        toGroup: toGroupsHash[that.toGroupFilter],
        groupItems: that.groupTransactions.filter(selectedFilter),
        memberItems: that.memberTransactions.filter(selectedFilter)
      };
      PaymentModalSvc.open(paymentObj).then(function(ft) {
        $state.go('group.view.financialTransaction.view', {ftId: ft.id});
      });
    };
  }
}

FinTxnSelectCtrl.$inject = [
  '$state',
  '$stateParams',
  '$location',
  '$filter',
  'LoaderSvc',
  'moment',
  'DatetimeSvc',
  'GroupSvc',
  'GroupAuthSvc',
  'GrpTxnSvc',
  'PaymentModalSvc'
];
